import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";

import { callAPI } from "../feature/APISlice";
import { openForm } from "../feature/formSlice";
import AdminNavbar from "./AdminNavbar";
import HomePageBannerForm from "../Form/HomePageBannerForm";

const BASE_URL = `${process.env.REACT_APP_PRODUCTION_API_URL}backend/api/admin/home-page-banners`;

export default function HomePageBannerList() {
  const dispatch = useDispatch();
  const { items, loading, error } = useSelector((s) => s.api);

  useEffect(() => {
    dispatch(callAPI({ method: "get", url: BASE_URL }));
  }, [dispatch]);

  return (
    <div>
      <AdminNavbar />

      <div className="customcontainer">
        <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "1rem" }}>
          <button
            className="admin-btn outline"
            onClick={() => dispatch(openForm(null))}
          >
            + Add Home Banner
          </button>
        </div>

        {loading && <p>Loading...</p>}
        {error && <p className="error-text">{error}</p>}

        <div className="admin-card-grid">
          {items.map((b) => (
            <div className="admin-card" key={b.id}>
              <div className="admin-card-header">
                <h4 className="admin-card-title">
                  {b.title || "No Title"}
                </h4>
              </div>

              <p className="admin-card-status">
                Status: {b.is_active ? " Active" : "❌ Inactive"}
              </p>

              <div className="admin-card-actions">
                <button
                  className="admin-card-btn"
                  onClick={() => dispatch(openForm(b.id))}
                >
                  ✏️
                </button>
                <button
                  className="admin-card-btn"
                  onClick={() =>
                    window.confirm("Delete this banner?") &&
                    dispatch(
                      callAPI({
                        method: "delete",
                        url: `${BASE_URL}/${b.id}`,
                        data: { id: b.id },
                      })
                    )
                  }
                >
                  🗑️
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      <HomePageBannerForm />
    </div>
  );
}
